import { Outlet, Link } from "react-router-dom";
import { Package } from "lucide-react";
import authImg from "@/assets/auth-illustration.jpg";

const MARKETING_URL = import.meta.env.VITE_SITE_URL ?? "/";

export default function AuthLayout() {
  return (
    <div className="grid min-h-dvh md:grid-cols-2">
      <div className="relative hidden overflow-hidden md:block">
        <img
          src={authImg}
          alt="Parcelio delivery illustration"
          width={1024}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/50 to-info/60 mix-blend-multiply" />
        <div className="relative z-10 flex h-full flex-col justify-between p-10 text-primary-foreground">
          <Link to="/" className="group inline-flex items-center gap-2.5">
            <div className="flex h-9 w-9 rotate-[-6deg] items-center justify-center rounded-xl bg-primary-foreground text-primary shadow-[2px_3px_0_0_oklch(0_0_0/0.25)] transition-transform duration-300 group-hover:rotate-0">
              <Package className="h-5 w-5" />
            </div>
            <span className="font-display text-lg font-semibold tracking-tight">Parcelio</span>
          </Link>
          <div className="max-w-md">
            <h2 className="text-3xl font-bold tracking-tight">
              The operator console trusted by 400+ logistics teams.
            </h2>
            <p className="mt-3 text-sm text-primary-foreground/80">
              Live tracking, driver comms, wallet and analytics — one login, everything you need to run last-mile at scale.
            </p>
            <div className="mt-8 grid grid-cols-3 gap-6 text-sm">
              {[
                ["96.4%", "On-time"],
                ["1.9s", "Data lag"],
                ["24/7", "Support"],
              ].map(([v, l]) => (
                <div key={l}>
                  <div className="text-2xl font-bold">{v}</div>
                  <div className="text-xs opacity-80">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <header className="flex items-center justify-between border-b bg-background/80 px-6 py-4 md:hidden">
          <Link to="/" className="group flex items-center gap-2">
            <div className="flex h-8 w-8 rotate-[-6deg] items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-[2px_3px_0_0_var(--blue-900)] transition-transform duration-300 group-hover:rotate-0">
              <Package className="h-4 w-4" />
            </div>
            <span className="font-display font-semibold tracking-tight">Parcelio</span>
          </Link>
          <a href={MARKETING_URL} className="text-sm text-muted-foreground hover:text-foreground">
            Back to site
          </a>
        </header>
        <div className="flex flex-1 items-center justify-center px-6 py-12 md:px-12">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
